import FormattedMessage from 'I18n/components/FormattedMessage';
import { render } from 'react-dom';
import { NavMarker, RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import rhumbConfig from '../../rhumb-config.yaml';
import { getHistory } from '../routing/history';
import { StyledUILink } from '../views-components/TextInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const setupAppError = () => {
  const rootElement = document.getElementsByClassName('page')[0];
  render( /*#__PURE__*/_jsx(RhumbProvider, {
    config: rhumbConfig,
    history: historyAdapter(getHistory()),
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "applicationError"
      }), /*#__PURE__*/_jsxs(UIErrorMessage, {
        type: "badRequest",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "error.STANDARD_CREATION_ERROR.subtitle"
          })
        }), /*#__PURE__*/_jsx(StyledUILink, {
          href: "https://hubspot.com",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "error.STANDARD_CREATION_ERROR.goBackToWebsite"
          })
        })]
      })]
    })
  }), rootElement);
};